<template>
    <div class="profileHeader">
        <div class="header-left" @click="back">
           <span class="iconfont iconzuojiantou"></span>
        </div>
        <div class="header-center">
           <p>用户登录</p>
        </div>
        <div class="header-right" @click="toHome">
           <span class="iconfont iconhome"></span>
        </div>
    </div>
</template>

<script>
export default {
   methods: {
      back () {
          this.$router.back()
      },
      toHome () {
         this.$router.push('/')
      }
   }
    
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
 .profileHeader
   z-index: 90
   display: flex
   justify-content: space-between
   width: 100%
   height: 40px
   align-items: center
   background-color: green
   color: white
   font-weight: bold
   .header-left
      margin-left: 8px
      height: 100%
      width: 40px
      display: flex
      align-items: center
   .header-right
      margin-right: 8px
      width: 40px
      height: 100%
      display: flex
      align-items: center
      justify-content: flex-end
</style>



// WEBPACK FOOTER //
// src/components/LoginHeader/LoginHeader.vue